export default {
  'en': {
    direction: 'ltr',
    isRtl: false,
    resources: {
      placeholder: "Enter some text...",
      normal: "Normal",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      heading4: "Heading 4",
      heading5: "Heading 5",
      heading6: "Heading 6",
      bulletList: "Bullet List",
      numberList: "Number List",
      quote: "Quote",
      code: "Code",
      align: 'Align',
      alignLeft: 'Left Align',
      alignCenter: 'Center Align',
      alignRight: 'Right Align',
      alignJustify: 'Justify Align',
      indent: 'Indent',
      outdent: 'Outdent',
      undo: 'Undo',
      redo: 'Redo',
      bold: "Bold",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      subscript: "Subscript",
      superscript: "Superscript",
      link: "Link",
      insert: "Insert",
      horizontalRule: "Horizontal Rule",
      image: "Insert Image",
      save: "Save",
      spellcheck: "Spellcheck",
      punctuation: "Punctuation",
      autoCorrect: "Auto Correct",
      tools: "Tools",
    },
  },
  'ur': {
    direction: 'rtl',
    isRtl: true,
    resources: {
      placeholder : "کچھ متن درج کریں۔۔۔",
      normal: "عام",
      heading1: "سرخی ۱",
      heading2: "سرخی ۲",
      heading3: "سرخی ۳",
      heading4: "سرخی ۴",
      heading5: "سرخی ۵",
      heading6: "سرخی ۶",
      bulletList: "فہرست",
      numberList: "عددی فہرست",
      quote: "کوٹ",
      code: "کوڈ",
      align: 'سیدھ',
      alignLeft: 'دائیں سیدھ',
      alignCenter: 'درمیانی سیدھ',
      alignRight: 'بائیں سیدھ',
      alignJustify: 'برابر سیدھ',
      indent: 'حاشیہ بڑھائیں',
      outdent: 'حاشیہ گھٹائیں',
      undo: 'کالعدم',
      redo: 'دوبارہ کریں',
      bold: "جلی",
      italic: "ترچھا",
      underline: "خط زد کریں",
      strikethrough: "اسٹرائیک کریں",
      subscript: "ذیلی نشان",
      superscript: "اعلی نشان",
      link: "ربط",
      insert: "متفرقات",
      horizontalRule: "افقی قاعدہ",
      image: "تصویر شامل کریں",
      save: "محفوظ کریں",
      spellcheck: "تصحیح",
      punctuation: "املا",
      autoCorrect: "خودکار تصحیح",
      tools: "آلات",
    }
  }
}
